import React from 'react';

import { MethodAlreadySelectedWrapper, TextContainer } from './styles';
import useConfigsStore from '../../store/configsStore';

export default function MethodAlreadySelected() {
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const order = useConfigsStore((state) => state.order);

  const isOrderPreviouslyApproved = order?.status?.index === 3;
  const email = order?.client?.email;
  return (
    <MethodAlreadySelectedWrapper
      fontFamily={devolutionPageConfigs?.fontFamily}
    >
      {isOrderPreviouslyApproved ? (
        <TextContainer>
          O método de devolução já foi selecionado para esse pedido!
          <br />
          <br />
          Por favor confira sua caixa de e-mail para mais informações.
        </TextContainer>
      ) : (
        <TextContainer>
          Método de devolução selecionado com sucesso!
          <br />
          <br />
          Aguarde a aprovação do seu pedido de devolução. Assim que aprovado,
          será enviado um e-mail para {email} com as instruções de devolução.
        </TextContainer>
      )}
    </MethodAlreadySelectedWrapper>
  );
}
